"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var default_1 = require("./default");
var dark_1 = require("./dark");
/** 所有的全局主题 */
var GLOBAL_THEME_MAP = {
    default: default_1.DEFAULT_GLOBAL_THEME,
    dark: dark_1.DEFAULT_DARK_THEME,
};
/**
 * 注册全局主题
 * @param name
 * @param theme
 */
function registerGlobalTheme(name, theme) {
    var defaultTheme = getGlobalTheme();
    GLOBAL_THEME_MAP[name.toLowerCase()] = _.deepMix({}, defaultTheme, theme);
}
exports.registerGlobalTheme = registerGlobalTheme;
/**
 * 获取默认主题
 * @param name 如果 name 为空，则返回默认的主题，否则返回指定 name 的主题
 */
function getGlobalTheme(name) {
    if (name === void 0) { name = 'default'; }
    var theme = GLOBAL_THEME_MAP[name.toLowerCase()];
    if (theme) {
        return theme;
    }
    // 如没有找到，则使用当前全局主题替代
    console.warn("error in theme: Can't find the theme named %s. Please register theme first.", name);
    return default_1.DEFAULT_GLOBAL_THEME;
}
exports.getGlobalTheme = getGlobalTheme;
//# sourceMappingURL=global.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/theme/global.js
// module id = 274
// module chunks = 37